import React from 'react';
import { Search, SearchIconWrapper, StyledInputBase } from 'components';
import { SearchIcon, CloseOutlinedIcon } from 'components/icons';
import { IconButton, Tooltip, Box } from 'components/mui';

interface KeywordSearchProps {
  searchInput: string;
  onSearchInput: (input: string) => void;
  onReset: () => void;
}

function KeywordSearch({ searchInput, onSearchInput, onReset }: KeywordSearchProps) {
  const onClick = () => {
    onSearchInput('');
    onReset();
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchInput(e.target.value);
  };

  return (
    <Box sx={{ width: '100%', '& > div': { width: '100%', ml: 0 }, '& .MuiInputBase-input': { width: '100% !important' } }}>
      <Search>
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
        <StyledInputBase
          placeholder="Search keywords..."
          value={searchInput}
          onChange={onChange}
          sx={{ width: '100%' }}
          endAdornment={
            searchInput ? (
              <Tooltip title="Clear">
                <IconButton onClick={onClick}>
                  <CloseOutlinedIcon />
                </IconButton>
              </Tooltip>
            ) : null
          }
        />
      </Search>
    </Box>
  );
}

export default KeywordSearch;
